import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [ "button", "list", "control" ]

  // Needed to prevent a flashing state between a :active and .open
  // in Safari.
  prepareToggle() {
    if (this.hasControlTarget) {
      this.controlTarget.classList.toggle("open")
    }
  }

  toggle() {
    const willOpen = !this.listTarget.classList.contains("open")
    this.listTarget.classList.toggle("open")

    // Force the control target to match that state,
    // even if prepareToggle() never ran.
    if (this.hasControlTarget) {
      this.controlTarget.classList.toggle("open", willOpen)
    }
    this.syncExpanded()
  }

  handleKey(event) {
    if (!this.hasControlTarget) return

    if (event.key === "Escape") {
      if (this.listTarget.classList.contains("open")) {
        this.listTarget.classList.remove("open")
        if (this.hasControlTarget) {
          this.controlTarget.classList.remove("open")
        }
        this.syncExpanded()
        this.controlTarget.focus()
        event.preventDefault()
      }
      return
    }

    if ((event.key === "Enter" || event.key === " ") &&
      (this.controlTarget.contains(event.target) || this.element === event.target) &&
      !this.listTarget.classList.contains("open")
    ) {
      this.toggle()
      event.preventDefault()
    }
  }

  // Don't cache menu in open state with Turbo Drive
  teardown() {
    this.close();
  }

  close() {
    this.listTarget.classList.remove("open")
    if (this.hasControlTarget) {
      this.controlTarget.classList.remove("open")
    }
    this.syncExpanded()
  }

  hide(event) {
    if (!this.element.contains(event.target)) {
      this.close();
    }
  }

  syncExpanded() {
    const expanded = this.listTarget.classList.contains("open")
    this.toggleButtons().forEach((target) => target.setAttribute("aria-expanded", expanded))
  }

  // Many menus still use a plain div as their button; aria-expanded is only valid on a button.
  toggleButtons() {
    return [...this.buttonTargets, ...this.controlTargets].filter((target) =>
      target.matches("button, [role=button]")
    )
  }
}
